import script from "./itemV2VariantsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV2VariantsList.vue?vue&type=script&setup=true&lang=ts"

import "./itemV2VariantsList.vue?vue&type=style&index=0&id=7326ee0d&lang=css"

const __exports__ = script;

export default __exports__